export enum TemplateList {
  BLESK = 'blesk',
}